<template>
  <pf-label class="pf-v6-u-font-size-sm" :color="color">{{ status }}</pf-label>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { $t as _t } from '@/i18n';
import { type Transfer } from '@/resources';
import type PfLabel from '@vue-patternfly/core/components/Label/Label.vue';
import type { ComponentProps } from 'vue-component-type-helpers';

type PfLabelProps = ComponentProps<typeof PfLabel>;

interface Props extends /* @vue-ignore */ Omit<PfLabelProps, 'color'> {
  transfer: Transfer;
}

const props = defineProps<Props>();

const color = computed(() => {
  switch (props.transfer.status) {
    case 'pending data':
    case 'customer testing':
      return 'red';
    case 'to schedule':
    case 'scheduled':
    case 'in progress':
      return 'blue';
    case 'completed':
      return 'green';
    case 'on hold':
    case 'canceled':
      return 'grey';
  }
});

const status = computed(() => {
  switch (props.transfer.status ) {
    case 'pending data':
      return _t('In attesa di dati');
    case 'to schedule':
      return _t('Da pianificare');
    case 'scheduled':
      return _t('Pianificato');
    case 'in progress':
      return _t('In corso');
    case 'customer testing':
      return _t('In attesa di test del cliente');
    case 'completed':
      return _t('Completato');
    case 'on hold':
      return _t('In sospeso');
    case 'canceled':
      return _t('Annullato');
  }
});
</script>
